var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"iframe",attrs:{"src":_vm.src,"sandbox":"allow-same-origin allow-scripts allow-modals allow-popups"}})}
var staticRenderFns = []

export { render, staticRenderFns }